var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notificationGroup", { attrs: { group: "top" } }, [
    _c(
      "div",
      { staticClass: "position-absolute d-block link-notif-group" },
      [
        _c("notification", {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var notifications = ref.notifications
                var close = ref.close
                return _vm._l(notifications, function (notification) {
                  return _c(
                    "div",
                    {
                      key: notification.id,
                      staticClass:
                        "d-flex max-w-sm w-100 mx-auto bg-white shadow-md rounded-lg overflow-hidden mt-4",
                      on: {
                        click: function ($event) {
                          return close(notification.id)
                        },
                      },
                    },
                    [
                      !notification.error
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center notification-zone bg-green-500",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "h-6 w-6 fill-current text-white",
                                  attrs: { viewBox: "0 0 40 40" },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center px-3 bg-red-500",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "h-6 w-6 fill-current text-white",
                                  attrs: { viewBox: "0 0 40 40" },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "py-2 px-3 d-flex w-100 justify-content-between",
                        },
                        [
                          _c(
                            "div",
                            { on: { click: notification.ntfAction } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "font-semibold",
                                  class: [
                                    notification.error
                                      ? "text-red-500"
                                      : "text-green-500",
                                  ],
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getNotificationTitleEncoding(
                                        notification
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(notification.textBlocs, function (text) {
                                return _c(
                                  "div",
                                  { key: "text-" + notification.id },
                                  [
                                    _c("p", { staticClass: "text-sm" }, [
                                      _vm._v(_vm._s(text)),
                                    ]),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("i", { staticClass: "fa fa-times fs-14px" }),
                          ]),
                        ]
                      ),
                    ]
                  )
                })
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }